export default "/blue-check.1758fdc0aa2d9860f0cc0afad1248527.svg";